import React                from 'react';
import { Button, Modal }    from 'react-bootstrap';
import { Dropdown }         from 'react-bootstrap';
import fileDownload         from 'js-file-download';

import clienteAxios         from '../../../../config/axiosSae';

import { ICON_CANCEL }      from '../../../extras/icons';
import { ICON_PAPERCLIP }   from '../../../extras/icons';

import { ErrorMessage }     from '../../../extras/toastMessages';



const ActuationView = props => {  
    
    
    // ============================================================================================
    // DECLARACIONES ------------------------------------------------------------------------------
    // ============================================================================================
    
    // Tomo los props
    const { actuation, handleClose, show } = props;


    // ============================================================================================
    // FUNCIONES ----------------------------------------------------------------------------------
    // ============================================================================================

    // Descargo los Archivos Adjuntos
    const handleDownload = async (adjunto) => {
        try {
            const response = await clienteAxios.get(`adjunto/${actuation.id}/download/${adjunto.nomb}`, {
                responseType: 'blob'
            });
            
            fileDownload(response.data, adjunto.nomb);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            // Verifico si hay error
            if(response)
            {   data = response.data;
            }
            // Mensaje de error
            ErrorMessage(data.message);
        }
    }
    

    // ============================================================================================
    // RENDERIZO ----------------------------------------------------------------------------------
    // ============================================================================================

    return (
        <Modal 
            centered = { true }
            onHide = { handleClose }
            scrollable = { true }
            show = { show }
            size = "xl"  
        >
            <Modal.Header closeButton={true}>
                <Modal.Title className="h5">
                    { actuation ?  `${actuation.tipoEscrito} | ${actuation.dscr}` : null }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 align-middle">
                        <div dangerouslySetInnerHTML={{__html: actuation ? actuation.texto : ''}} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer 
                className = "bg-light" 
                style = {{ 
                    alignItems: 'start', 
                    height: `${ actuation && actuation.adjuntosList.length ? (actuation.adjuntosList.length*34+72) : 72 }px`,
                    overflow: 'auto' 
                }}
            >
                <div className="row" style={{'width':'100%'}}>
                    <div className="col-6">
                        {   actuation && actuation.adjuntosList.length>0
                                ?
                                    <Dropdown>
                                        <Dropdown.Toggle variant="warning"><ICON_PAPERCLIP /> Adjuntos</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {   actuation.adjuntosList.map( (el,index)=>
                                                    <Dropdown.Item 
                                                        eventKey = { index }
                                                        key = { index }
                                                        onClick = { ()=>{ handleDownload(el) } } 
                                                    >
                                                        <strong>ADJUNTO #{index+1} ({el.exte.toUpperCase()})</strong> - <i>DESCARGAR</i>
                                                    </Dropdown.Item>
                                                )   
                                            }
                                        </Dropdown.Menu>    
                                    </Dropdown>
                                :
                                    null
                        }
                    </div>
                    <div className="col-6 text-right">
                        <Button variant="danger" onClick={handleClose}>
                            <ICON_CANCEL /> Cerrar
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ActuationView;